import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { WORKER_POOL_SHARED_LABEL, WORKER_POOL_SHARED_VALUE } from "constants/workerPool";
import { WorkerPool } from "types/generated";
import { isSaasDistribution, withoutPublicWorkerPool } from "utils/distribution";

import { GET_ATTACHABLE_WORKER_POOLS_IN_SPACE } from "./gql";

const isSaas = isSaasDistribution();
const withPublicWorkerPool = isSaas && !withoutPublicWorkerPool();

export const useWorkerPoolOptions = (space: string) => {
  const { data, loading, error, refetch, networkStatus } = useQuery<{
    attachableWorkerPoolsInSpace: WorkerPool[];
  }>(GET_ATTACHABLE_WORKER_POOLS_IN_SPACE, {
    variables: {
      id: space,
    },
  });

  const workerPools = useMemo(
    () =>
      data?.attachableWorkerPoolsInSpace.map((item) => ({
        value: item.id,
        label: item.name,
      })),
    [data?.attachableWorkerPoolsInSpace]
  );

  const workerPoolsOptions = useMemo(
    () => [
      // Only show the public worker pool option for SaaS. Self-hosting only supports private workers.
      ...(withPublicWorkerPool
        ? [{ value: WORKER_POOL_SHARED_VALUE, label: WORKER_POOL_SHARED_LABEL }]
        : []),
      ...(workerPools || []),
    ],
    [workerPools]
  );

  return {
    workerPoolsOptions,
    loading,
    error,
    hasData: !!data,
    refetch,
    networkStatus,
  };
};
